import 'bootstrap/js/src/tooltip'

document.addEventListener 'turbo:load', ->
  $('[data-toggle=tooltip]').tooltip()